
import { Component, Vue, Watch } from "vue-property-decorator";
import request from "@/lib/request/request";
import { QuestionPaper } from "@/lib/model/question/question"; //questionlist Model
import QuestionCard from "@/components/question/QuestionCard.vue";
import draggable from "vuedraggable";
import QuestionEdit from "./question-edit.vue"; //编辑弹窗
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import PaperSteps from "@/components/exam/paper-steps.vue";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import vuexStore from "@/store/vuex-store";
import Loading from "../../components/loading.vue";

import { Question } from "@/lib/model/question/question"; //question Model
import { isShunfengCompany } from "@/utils/sf";
@Component({
  components: {
    QuestionCard,
    draggable,
    QuestionEdit,
    Breadcrumb,
    PaperSteps,
    Loading
  }
})
export default class QuestionPaperVue extends Vue {
  $refs!: { edit: HTMLFormElement };
  questionList: Question[] = [];
  paperId = 0;
  questionNumber = 0; //题数
  scoreAll = 0; //总分
  from = ""; //来自 新建还是编辑
  cantEdit = false; //是否不可编辑试卷
  paperStepType = "add";
  examName = "";
  examRemark = "";
  examGetForm = new ExamGetForm();
  sideCol = true; //侧边栏收起
  sideStatus = ""; //侧边栏状态
  dataReady = false;
  @Watch("side") //底部按钮位移动画
  sideChanged(n: boolean) {
    this.sideCol = n;
    this.sideStatus = n ? "in" : "out";
  }
  get side() {
    return vuexStore.sideIsCollapse;
  }

  mounted() {
    this.sideCol = !JSON.parse(localStorage.getItem("lock") || "false");
    const param = this.$route?.query; //入参
    this.cantEdit = param.canEdit === "1" ? true : false;
    this.paperId = Number(param?.paperId) || 0;
    this.from = String(param?.from); //必须， 从哪个页面跳入最后就跳回哪个页面。edit或者add
    if (!this.from) {
      this.$message.warning("参数异常，缺少from值，请重试！");
      this.$router.go(-1);
      return;
    }
    if (param?.questionId) {
      this.handleAdd(Number(this.$route.query.questionId)); //新建面试 且 直接新建试题
      return;
    }
    this.getExamInfo();
    this.getList();
  }
  //移动至第几题
  sort(to: any, from: number) {
    const temp = this.questionList[from];
    this.questionList.splice(from, 1);
    this.questionList.splice(Number(to) - 1, 0, temp); //先删后插
  }
  //获取当前排序
  getSort() {
    const IdList: number[] = [];
    this.questionList.forEach(d => {
      IdList.push(d.questionId);
    });
    return IdList;
  }
  //修改排序
  sendSort() {
    return this.sendRequest("aiExam/examQuestions/set", {
      examId: this.paperId,
      questionIdList: this.getSort()
    });
  }
  //修改分值、时长
  sendScore() {
    return this.sendRequest("aiExam/examQuestions/mUpdate", {
      examId: this.paperId,
      questionList: this.questionList
    });
  }
  //提交
  submit() {
    this.sendSort()
      .then(this.sendScore)
      .then(() => {
        const url =
          this.from === "add"
            ? `/paper-edit?paperId=${this.paperId}&step=4`
            : `/exam/paper`;
        this.$router.push(url);
      });
  }
  cancel() {
    if (isShunfengCompany(Auth.companyId)) {
      this.$router.push(`/exam/paper-sf`);
    } else {
      this.$router.push(`/exam/paper`);
    }
  }
  //新增弹窗
  add() {
    this.$refs.edit.open();
  }
  //创建新题后回调 新ID直接加入此试卷
  handleAdd(id: number) {
    if (!id) {
      this.getList();
      return;
    }
    this.sendRequest("aiExam/examQuestions/set", {
      examId: this.paperId,
      questionIdList: this.getSort().concat([id])
    }).then(() => {
      this.getList();
    });
  }
  //删除
  del(q: Question) {
    this.sendRequest("aiExam/examQuestions/remove", {
      examId: this.paperId,
      questionId: q.questionId
    }).then(res => {
      this.$message.success("删除成功！");
      this.getList();
      //
    });
  }
  //编辑
  openQuestion(question?: any) {
    this.$refs.edit.open(question);
  }
  //拖拽结束
  datadragEnd(a: any, b: any, c: any) {
    //已经自动更新数组
  }
  //跳转题库
  toStore() {
    this.$router.push(
      `/question-store?state=select&paperId=${
        this.paperId
      }&selectedIdList=${this.getSort().join(",")}&from=${this.from}`
    );
  }

  getList() {
    this.dataReady = false;
    //加载试卷题目
    QuestionPaper.get({ examId: this.paperId }, "aiExam/examQuestions/get")
      .then(res => {
        this.questionList = res.questionList;
        this.questionNumber = res.questionNumber;
        this.scoreAll = res.scoreAll;
        this.dataReady = true;
      })
      .finally(() => {
        this.dataReady = true;
      });
  }

  getExamInfo() {
    this.examGetForm.examId = this.paperId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    ExamList.examGet(this.examGetForm).then(res => {
      this.examName = res.name;
      this.examRemark = res.remark;
    });
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then(
        (resp: { data: any; code: any; message: any }) => {
          if (resp.data.code === 0) {
            resolve(resp.data.data);
          } else {
            reject(resp.data.message);
          }
        }
      );
    }).catch(e => {
      console.log(e);
    });
  }
}
